module.exports = __webpack_public_path__ + "media/application/images/svgs/public_square/search-49d4282edef6839ae906d1d0a51d27a9.svg";